<div class="reports-section" [class.rtl]="currLang == 'ar'">
  <app-reports-control-bar [controlType]="'flow-log'"></app-reports-control-bar>
  <div id="report-card">
    <h3 class="main-header">{{ "side-nav.dashboard" | translate }}</h3>
    <app-students-dismissal-tracking *ngIf="userPlan === 'paid'"></app-students-dismissal-tracking>
    <app-school-dimissal-flow-log *ngIf="userPlan === 'paid'" [showHeader]="true"></app-school-dimissal-flow-log>
    <!-- attendance charts -->
    <div class="attendance-container" [ngStyle]="{ 'text-align': currLang == 'en' ? 'left' : 'right' }">
      <div *ngIf="attendanceLoading" class="attendance-loading">
        <mat-spinner *ngIf="true" mode="indeterminate"></mat-spinner>
      </div>
      <label (click)="openAttendanceReprots()" class="attendance-label">{{ "dashboard-reports.attendance" | translate }}
        <svg xmlns="http://www.w3.org/2000/svg" width="6.576" height="11.257" viewBox="0 0 6.576 11.257" [ngStyle]="{
            transform: currLang == 'en' ? 'rotate(0)' : 'rotate(180deg)'
          }">
          <g id="next_1_" data-name="next (1)" transform="translate(0.554 0.554)">
            <g id="Group_5442" data-name="Group 5442" transform="translate(0 0)">
              <path id="Path_5603" data-name="Path 5603"
                d="M107.651,5.354l-4.687,4.687a.391.391,0,0,1-.552-.552l4.411-4.411L102.411.667a.391.391,0,0,1,.552-.552L107.651,4.8A.391.391,0,0,1,107.651,5.354Z"
                transform="translate(-102.297 0)" fill="#1d71d3" stroke="#1d71d3" stroke-width="1" />
            </g>
          </g>
        </svg>
      </label>
      <div class="attendance-section">
        <div class="attendance-section-chart">
          <div class="chart" *ngIf="barChartData">
            <canvas baseChart [datasets]="barChartData" [labels]="barChartLabels" [options]="barChartOptions"
              [legend]="barChartLegend" [type]="barChartType">
            </canvas>
            <div class="legends">
              <span>
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g id="ICO/color/color3">
                    <path id="Combined Shape" fill-rule="evenodd" clip-rule="evenodd"
                      d="M6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0ZM6 3C4.34315 3 3 4.34315 3 6C3 7.65685 4.34315 9 6 9C7.65685 9 9 7.65685 9 6C9 4.34315 7.65685 3 6 3Z"
                      fill="#48E3FF" />
                  </g>
                </svg>
                Absent
              </span>
              <span>
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g id="ICO/color/color2">
                    <path id="Combined Shape" fill-rule="evenodd" clip-rule="evenodd"
                      d="M6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0ZM6 3C4.34315 3 3 4.34315 3 6C3 7.65685 4.34315 9 6 9C7.65685 9 9 7.65685 9 6C9 4.34315 7.65685 3 6 3Z"
                      fill="#1D71D3" />
                  </g>
                </svg>
                Present
              </span>
            </div>
          </div>
        </div>
        <div class="attendance-count">
          <div class="attendance-count-present">
            <span>{{ totalPresentStudents ? totalPresentStudents : 0 }}</span>
            <small>{{ "dashboard-reports.presence" | translate }}</small>
          </div>
          <div class="attendance-count-absent">
            <span>{{ totalAbsentStudents ? totalAbsentStudents : 0 }}</span>
            <small>{{ "dashboard-reports.absent" | translate }}</small>
          </div>
        </div>
      </div>
    </div>
    <div class="pickup-container" *ngIf="userPlan === 'paid'"
      [ngStyle]="{ 'text-align': currLang == 'en' ? 'left' : 'right' }">
      <div *ngIf="pickupLoading" class="pickup-loading">
        <mat-spinner *ngIf="true" mode="indeterminate"></mat-spinner>
      </div>
      <label class="students-pickup-label">{{
        "dashboard-reports.pickedup-students" | translate
        }}</label>
      <div class="students-pickup-section">
        <div class="students-pickup-section-charts">
          <div class="pie-chart-btns">
            <button (click)="toggleBtn('week')" [class]="activeBtn === 'week' ? 'btn active' : 'btn'">
              {{ "dashboard-reports.last-week" | translate }}
            </button>
            <button (click)="toggleBtn('month')" [class]="
                activeBtn === 'month' ? 'btn month-btn active' : 'btn month-btn'
              ">
              {{ "dashboard-reports.last-month" | translate }}
            </button>
          </div>
          <div class="line-chart" *ngIf="lineChartData">
            <canvas baseChart [datasets]="lineChartData" [labels]="lineChartLabels" [options]="lineChartOptions"
              [legend]="lineChartLegend" [type]="barChartType" (chartClick)="chartClicked($event)">
              >
            </canvas>
          </div>
          <!-- <div class="pie-chart">
                        <canvas baseChart [datasets]="pieChartData" [labels]="pieChartLabels"
                            [options]="pieChartOptions" [legend]="pieChartLegend" [chartType]="pieChartType">
                        </canvas>
                    </div> -->
          <div class="pie-indicators">
            <div class="using-indicator">
              <div (click)="t1.open()" class="using-chart"></div>
              <span triggers="manual" #t1="ngbTooltip" placement="bottom" tooltipClass="my-custom-class"
                [ngbTooltip]="infoTemplate1">{{ usingBlueride }}
                {{ "dashboard-reports.using-blueride" | translate }}
                {{ onDate }}</span>
            </div>
            <ng-template #infoTemplate1>
              <div class="info-container">
                <!-- <span (click)="sendMessage('active')" style="cursor: pointer;"
                                    class="header">{{'dashboard-reports.send-msg' | translate}}</span><br><br> -->
              </div>
            </ng-template>
            <!-- not using blueride -->
            <div (click)="t2.open()" class="not-using-indicator">
              <div class="not-using-chart"></div>
              <span triggers="manual" #t2="ngbTooltip" placement="bottom" tooltipClass="my-custom-class"
                [ngbTooltip]="infoTemplate2">{{ notUsingBlueride }}
                {{ "dashboard-reports.not-using-blueride" | translate }}
                {{ onDate }}</span>
            </div>
            <ng-template #infoTemplate2>
              <div class="info-container">
                <span (click)="sendMessage()" style="cursor: pointer" class="header">{{ "dashboard-reports.send-msg" |
                  translate }}</span><br /><br />
              </div>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
    <!-- <div
      class="school-bus-system-container"
      *ngIf="userPlan === 'paid'"
      [ngStyle]="{ 'text-align': currLang == 'en' ? 'left' : 'right' }"
    >
      <div *ngIf="schoolLoading" class="school-loading">
        <mat-spinner *ngIf="true" mode="indeterminate"></mat-spinner>
      </div>
      <label class="school-bus-system-label">{{
        "dashboard-reports.bus-system" | translate
      }}</label>
      <div class="school-bus-system-section">
        <div class="hor-bar-chart" *ngIf="horizontalBarChartData">
          <canvas
            height="100px"
            baseChart
            [datasets]="horizontalBarChartData"
            [labels]="horizontalBarChartLabels"
            [options]="horizontalBarChartOptions"
            [legend]="horizontalBarChartLegend"
            [type]="horizontalBarChartType"
          >
          </canvas>
        </div>
        <div class="school-bus-system-section-count">
          <div class="buses">
            <span>{{ schoolBusSystem.buses_count }}</span>
            <small>{{ "dashboard-reports.buses" | translate }}</small>
          </div>
          <div class="drivers">
            <span>{{ schoolBusSystem.drivers_count }}</span>
            <small>{{ "dashboard-reports.drivers" | translate }} </small>
          </div>
          <div class="supervisors">
            <span>{{ schoolBusSystem.buses_supervisors_count }}</span>
            <small>{{ "dashboard-reports.supervisors" | translate }}</small>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</div>